// import { makeStyles } from '@material-ui/core';

// export const useStyles = makeStyles((theme) => ({
//   paper: {
//     padding: theme.spacing(2),
//     marginBottom: theme.spacing(2),
//     width: '100%',
//   },
//   title: {
//     marginBottom: theme.spacing(2),
//     fontWeight: 600,
//     color: theme.palette.primary.main,
//   },
//   list: {
//     padding: 0,
//     width: '100%',
//     backgroundColor: '#fff',
//   },

//   listItem: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     padding: '12px 16px',
//     borderBottom: 'none',
//     gap: 8,
//     '&:hover': {
//       backgroundColor: '#fafbff',
//     },
//   },

//   avatar: {
//     width: 52,
//     height: 52,
//     backgroundColor: '#eef3ff',
//     color: '#5282ff',
//     fontSize: 25,
//   },

//   avatarRemove: {
//     width: 52,
//     height: 52,
//     backgroundColor: '#ffeeee',
//     color: '#d32f2f',
//     fontSize: 25,
//   },

//   eventContent: {
//     minWidth: 0,
//     marginTop: 2,
//   },

//   eventTitle: {
//     fontSize: 16,
//     fontWeight: 600,
//     color: '#171717',
//     lineHeight: 1.5,
//   },

//   eventDescription: {
//     marginTop: 5,
//   },

//   description: {
//     fontSize: 14,
//     color: '#707080',
//     lineHeight: 1.5,
//   },

//   eventMeta: {
//     marginTop: 6,
//     fontSize: 14,
//     color: '#707080',
//   },

//   userLink: {
//     color: '#477cff',
//     cursor: 'pointer',
//     '&:hover': {
//       textDecoration: 'underline',
//     },
//   },

//   eventActions: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: 10,
//     marginLeft: 'auto',
//     paddingLeft: 16,
//     minWidth: 112,
//   },

//   statusChip: {
//     height: 36,
//     borderRadius: 24,
//     backgroundColor: '#e2e2e2',
//     color: '#222',
//     fontSize: 16,
//     '& .MuiChip-label': {
//       paddingLeft: 16,
//       paddingRight: 16,
//     },
//   },

//   detailsLink: {
//     color: '#477cff',
//     fontSize: 15,
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     '&:hover': {
//       textDecoration: 'underline',
//     },
//   },
//   // list: {
//   //   overflow: 'auto',
//   // },
//   // listItem: {
//   //   padding: theme.spacing(1),
//   //   borderBottom: `1px solid ${theme.palette.divider}`,
//   //   '&:last-child': {
//   //     borderBottom: 'none',
//   //   },
//   // },
//   // avatar: {
//   //   backgroundColor: theme.palette.primary.main,
//   //   width: theme.spacing(4),
//   //   height: theme.spacing(4),
//   // },
//   primaryText: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: theme.spacing(1),
//   },
//   typeChip: {
//     height: '20px',
//     fontSize: '0.75rem',
//   },
//   secondaryText: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: theme.spacing(0.5),
//   },
//   // description: {
//   //   marginTop: theme.spacing(0.5),
//   //   fontStyle: 'italic',
//   // },
//   loading: {
//     textAlign: 'center',
//     padding: theme.spacing(2),
//     color: theme.palette.text.secondary,
//   },
//   emptyState: {
//     textAlign: 'center',
//     padding: theme.spacing(3),
//   },
//   dateSeparator: {
//     // display: 'flex',
//     // alignItems: 'center',
//     padding: '10px 16px 4px',
//     // '&::before': { content: '""', flex: 1, height: 1, backgroundColor: '#e0e0e0', marginRight: 12 },
//     // '&::after': { content: '""', flex: 1, height: 1, backgroundColor: '#e0e0e0', marginLeft: 12 },
//   },
//   dateSeparatorText: {
//     fontSize: 16,
//     fontWeight: 600,
//     color: '#888',
//     whiteSpace: 'nowrap',
//     backgroundColor: '#fff',
//     padding: '2px',
//     // borderRadius: 12,
//     // border: '1px solid #e0e0e0',
//   },
//   toolbar: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     marginBottom: theme.spacing(1),
//     gap: theme.spacing(1),
//   },
// }));

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  timelinePaper: {
    background: '#FFFFFF',
    border: '1px solid #E7EBF2',
    borderRadius: 8,
    boxShadow: 'none',
    padding: '24px',
    width: '100%',
    boxSizing: 'border-box',
  },

  timelineHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },

  heading: {
    fontSize: 20,
    fontWeight: 600,
    color: '#171C2E',
  },

  eventCount: {
    fontSize: 12,
    color: '#7C8596',
  },

  exportButton: {
    background: '#087BFF',
    color: '#FFFFFF',
    fontSize: 11,
    fontWeight: 600,
    padding: '8px 18px',
    boxShadow: 'none',
    '&:hover': {
      background: '#0067DE',
    },
    '&:disabled': {
      background: '#DDE3EB',
    },
  },

  filterRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(200px, 2fr) repeat(3, minmax(130px, 1fr))',
    gap: 12,
    marginBottom: 12,
    '& .MuiOutlinedInput-root': {
      fontSize: 12,
      borderRadius: 5,
      height: 40,
    },
    '@media (max-width: 900px)': {
      gridTemplateColumns: '1fr 1fr',
    },
    '@media (max-width: 520px)': {
      gridTemplateColumns: '1fr',
    },
  },

  searchInput: {
    width: '100%',
  },

  filterSummary: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#8A92A1',
    marginBottom: 14,
    '& .MuiTypography-root': {
      fontSize: 11,
      color: '#8A92A1',
    },
  },

  timelineBody: {
    minHeight: 280,
    paddingTop: 18,
  },

  dateGroup: {
    marginBottom: 16,
  },

  dateHeading: {
    fontSize: 12,
    fontWeight: 600,
    color: '#687386',
    marginBottom: 12,
  },

  eventRow: {
    display: 'flex',
    position: 'relative',
    gap: 14,
    paddingBottom: 22,
    '&:not(:last-child) $iconColumn:after': {
      content: '""',
      position: 'absolute',
      top: 34,
      bottom: -22,
      left: 16,
      width: 1,
      background: '#E5EBF5',
    },
  },

  iconColumn: {
    position: 'relative',
    flexShrink: 0,
    width: 34,
  },

  eventAvatar: {
    width: 32,
    height: 32,
    background: '#EAF2FF',
    color: '#4383FF',
    '& svg': {
      fontSize: 17,
    },
  },

  removedAvatar: {
    background: '#FFF0F0',
    color: '#E45858',
  },

  eventMain: {
    flex: 1,
    minWidth: 0,
  },

  eventTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: '#202638',
    marginBottom: 4,
  },

  description: {
    fontSize: 12,
    color: '#677184',
    lineHeight: 1.6,
    overflowWrap: 'anywhere',
  },

  eventMeta: {
    fontSize: 11,
    color: '#8A94A6',
    marginTop: 4,
  },

  blueLink: {
    color: '#4383FF',
    cursor: 'pointer',
  },

  eventActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
    minWidth: 90,
  },

  statusChip: {
    height: 23,
    background: '#ECEEF1',
    color: '#4C5668',
    fontSize: 11,
    textTransform: 'lowercase',
  },

  detailsButton: {
    color: '#4383FF',
    fontSize: 11,
    textTransform: 'none',
    padding: '2px 0',
    minWidth: 'auto',
  },

  detailsPanel: {
    background: '#F7F9FC',
    borderRadius: 5,
    padding: 12,
    marginTop: 12,
    color: '#697488',
  },

  changesTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 11,
    textAlign: 'left',
    '& th': {
      color: '#667187',
      fontWeight: 600,
      padding: '8px 10px',
      background: '#EFF3F9',
    },
    '& td': {
      color: '#596477',
      padding: '8px 10px',
      borderBottom: '1px solid #E7EBF2',
    },
  },

  emptyState: {
    textAlign: 'center',
    padding: 50,
    color: '#8792A4',
    fontSize: 13,
  },

  pagination: {
    borderTop: '1px solid #EDF0F5',
    paddingTop: 10,
    '& .MuiTablePagination-root': {
      border: 'none',
    },
    '& .MuiTablePagination-caption': {
      fontSize: 11,
      color: '#788397',
    },
  },
}));
